import { useState } from 'react';
import { nonce } from '..';
import { noop } from 'lodash/fp';
import { fold } from 'fp-ts/lib/Either';

export function useNonce() {
  const [value, set] = useState('');

  return {
    nonce: value,
    callNonce: () => nonce().then(fold<undefined, string, void>(noop, set)),
  };
}
